import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminRoute from 'routes/AdminRoute';
import { default as PrivateRoute } from 'routes/PrivateRoute';

const Admin = React.lazy(() => import('pages/Admin/Admin'));
const Skins = React.lazy(() => import('pages/Skins/Skins'));
const Home = React.lazy(() => import('pages/Home/Home'));
const Error = React.lazy(() => import('pages/Error/Error'));

const AppRoutes = () => {
    return (
        <Routes>
            <Route path={'/'} Component={Home} />
            <Route path={'/inventory'} Component={PrivateRoute}>
                <Route path={'/inventory'} Component={Skins} />
            </Route>
            <Route path={'/admin'} Component={AdminRoute}>
                <Route path={'/admin'} Component={Admin} />
            </Route>
            <Route path={'/error'} Component={Error} />
        </Routes>
    );
};

export default AppRoutes;
